import { createContext, useContext } from 'react';
export var TabsContext = /*#__PURE__*/createContext({});
export var useTabsContext = function () {
  return useContext(TabsContext);
};